import { Logo } from "@/components/Logo";

export function Footer() {
  return (
    <footer className="relative bg-[#0F1012] border-t border-amber-500/10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <Logo />
          <p className="mt-6 text-xs text-zinc-500 leading-relaxed max-w-xs">
            A discreet chauffeur house for private clients. Immaculate vehicles, formally trained chauffeurs, journeys
            composed to the minute.
          </p>
        </div>
        <div>
          <p className="font-mono-lux text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-5">House</p>
          <ul className="space-y-3 text-sm text-zinc-400">
            <li><a href="/#fleet" className="hover:text-amber-300 transition-colors">The Fleet</a></li>
            <li><a href="/#services" className="hover:text-amber-300 transition-colors">Services</a></li>
            <li><a href="/packages" className="hover:text-amber-300 transition-colors">Packages</a></li>
            <li><a href="/book" className="hover:text-amber-300 transition-colors">Reserve a Journey</a></li>
            <li><a href="/track" className="hover:text-amber-300 transition-colors">Track My Ride</a></li>
            <li><a href="/gift" className="hover:text-amber-300 transition-colors">Gift Vouchers</a></li>
            <li><a href="/#contact" className="hover:text-amber-300 transition-colors">Contact</a></li>
          </ul>
        </div>
        <div>
          <p className="font-mono-lux text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-5">Correspondence</p>
          <ul className="space-y-3 text-sm text-zinc-400">
            <li>concierge@aureusluxury.com</li>
            <li>+1 (786) 874-0320</li>
            <li>Palm Beach, South Florida — by appointment</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-wrap items-center justify-between gap-4">
          <p className="font-mono-lux text-[10px] uppercase tracking-[0.25em] text-zinc-600">
            © {new Date().getFullYear()} AUREUS Executive Chauffeur
          </p>
          <a
            href="/admin/login"
            data-testid="footer-admin-link"
            className="font-mono-lux text-[10px] uppercase tracking-[0.25em] text-zinc-700 hover:text-amber-500 transition-colors"
          >
            Concierge Access
          </a>
        </div>
      </div>
    </footer>
  );
}
